import React from "react"
import { Flex, Heading, Subhead } from "rebass"
import CircleIcon from "../CircleIcon"

const FadeInFeature = props => (
  <Flex flexDirection="column" alignItems="center" justifyContent="center">
    <CircleIcon
      borderColor={props.borderColor}
      bg={props.iconBg}
      icon={props.icon}
      color={props.iconColor}
      hoverColor={props.hoverColor}
      size="3x"
    />
    <Heading fontSize={2} pt={4}>
      {props.heading}
    </Heading>
    <Flex pt={2}>
      <p style={{ textAlign: "center", color: "white" }}>{props.subheading}</p>
    </Flex>
  </Flex>
)

export default FadeInFeature



// WEBPACK FOOTER //
// ./src/components/FadeInFeature/index.js